export default __webpack_public_path__ + "static/media/sibling-rivalry@2x 4.4b9a2c53.png";